module.exports = __webpack_public_path__ + "static/sport/bgi-form.4849364.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-form.png
// module id = Op1d
// module chunks = 0